export default __webpack_public_path__ + "../img/df52f71dca19b1687d9b121c59b684f7.png";